/**
 * MP Price Slider — syncs dual range inputs with the Fabric price-facet-component.
 * Runs after DOMContentLoaded and re-initialises on Shopify section:load events.
 */
(function mpPriceSlider() {
  function init() {
    document.querySelectorAll('.mp-price-slider:not([data-mp-init])').forEach(function (slider) {
      slider.setAttribute('data-mp-init', '1');

      var minRange   = slider.querySelector('.mp-price-slider__input--min');
      var maxRange   = slider.querySelector('.mp-price-slider__input--max');
      var rangeEl    = slider.querySelector('.mp-price-slider__range');
      var wrapper    = slider.querySelector('.mp-price-slider__track-wrapper');
      var priceFacet = slider.closest('price-facet-component');
      if (!minRange || !maxRange || !priceFacet) return;

      var minInput = priceFacet.querySelector('[ref="minInput"]');
      var maxInput = priceFacet.querySelector('[ref="maxInput"]');
      var sliderMax = parseFloat(slider.dataset.max) || 100;

      /* ---------- helpers ---------- */
      function pct(val) { return (parseFloat(val) / sliderMax * 100).toFixed(2) + '%'; }

      function updateTrack() {
        var lo = parseFloat(minRange.value);
        var hi = parseFloat(maxRange.value);
        rangeEl.style.left  = pct(lo);
        rangeEl.style.width = pct(hi - lo);
        if (wrapper) {
          wrapper.style.setProperty('--thumb-left',  pct(lo));
          wrapper.style.setProperty('--thumb-right', pct(hi));
        }
      }

      function clamp(val, lo, hi) { return Math.max(lo, Math.min(hi, val)); }

      /* ---------- slider → inputs ---------- */
      function onSliderInput(e) {
        var lo = parseFloat(minRange.value);
        var hi = parseFloat(maxRange.value);
        if (lo > hi) {
          if (e.target === minRange) { minRange.value = hi; lo = hi; }
          else                       { maxRange.value = lo; hi = lo; }
        }
        if (minInput) minInput.value = (lo === 0)        ? '' : String(lo);
        if (maxInput) maxInput.value = (hi >= sliderMax) ? '' : String(hi);
        updateTrack();
      }

      /* ---------- inputs → slider ---------- */
      function onInputChange() {
        var lo = clamp(parseFloat(minInput && minInput.value) || 0,         0, sliderMax);
        var hi = clamp(parseFloat(maxInput && maxInput.value) || sliderMax, 0, sliderMax);
        minRange.value = Math.min(lo, hi);
        maxRange.value = Math.max(lo, hi);
        updateTrack();
      }

      minRange.addEventListener('input', onSliderInput);
      maxRange.addEventListener('input', onSliderInput);
      if (minInput) minInput.addEventListener('change', onInputChange);
      if (maxInput) maxInput.addEventListener('change', onInputChange);

      updateTrack();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when Shopify re-renders a section in the Theme Editor */
  document.addEventListener('shopify:section:load', init);
})();
